module.exports = __webpack_public_path__ + "img/picture10.193805c3.png";